// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"238":"2e2e48c1e0825c05","405":"aa0f302447bf1eac","616":"aa0f302447bf1eac","888":"28c36c2656b72512"}[chunkId] + ".css";
};